import { useCallback, useState } from "react";
import { message } from "antd";
import {
  ADMIN_GAMES_GET_TO_SYNC,
  ADMIN_GAMES_UPDATE_TO_SYNC,
} from "../../../../constants/api";
import { syncApi } from "./syncApi";

export const useSyncActions = () => {
  const [syncData, setSyncData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isMerging, setIsMerging] = useState(false);

  const getSyncData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await syncApi.get(ADMIN_GAMES_GET_TO_SYNC);
      setSyncData(response.data);
    } catch (error) {
      console.error("Erro ao buscar diferenças de sincronização:", error);
      message.error("Não foi possível carregar as diferenças de sincronização.");
      setSyncData(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const mergeSelected = useCallback(async (payload) => {
    try {
      setIsMerging(true);
      await syncApi.post(ADMIN_GAMES_UPDATE_TO_SYNC, payload);
      return true;
    } catch (error) {
      console.error("Erro ao mergear itens selecionados:", error);
      message.error("Não foi possível mergear os itens selecionados.");
      return false;
    } finally {
      setIsMerging(false);
    }
  }, []);

  return { syncData, isLoading, getSyncData, mergeSelected, isMerging };
};
